/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SummaryCountResponse {
    getFixupPrototypeFunction() { return SummaryCountResponse.fixupPrototype; }

    static newInstance(model: Partial<SummaryCountResponse>): SummaryCountResponse {
        let obj = Object.assign(new SummaryCountResponse(), model);
        SummaryCountResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SummaryCountResponse>): SummaryCountResponse {
        if (!model) return null;
        return SummaryCountResponse.newInstance(<SummaryCountResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SummaryCountResponse) {
        if (!obj) return;

        models.SummaryCountResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SummaryCountResponse): boolean {
        Object.setPrototypeOf(obj, SummaryCountResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.violations) {
            models.ViolationCategoryModel.fixupPrototype(this.violations);
        }
    }

    /**
     * Contains the summary of violations shared under Utilization/Standards for AWS/Azure
     */
    violations: models.ViolationCategoryModel;

}
